import { BaseService } from './base-service.template';
import { Pagination } from '../../models/pagination/pagination.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { getHttpHeader } from '../../utils/http-header.factory';
import { ApiVisa } from '../../models/base/apivisa.model';
import { PagingResponseModel } from '../../models/base/paging-response.model';

export class QueryService<T> implements BaseService {
    
  public readonly apiUrl: string;
  protected readonly http: HttpClient;

  constructor(url: string, http: HttpClient) { 
    this.http = http;
    this.apiUrl = url;
  }

  public getByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<T>>{
    return this.http.get<PagingResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
